import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  openMenu: {
    id: 'common.open-menu',
    defaultMessage: 'Open menu',
  },
  closeMenu: {
    id: 'common.close-menu',
    defaultMessage: 'Close menu',
  },
  nextSlide: {
    id: 'common.next-slide',
    defaultMessage: 'Go to next slide',
  },
  prevSlide: {
    id: 'common.prev-slide',
    defaultMessage: 'Go to previous slide',
  },
  open: {
    id: 'common.open',
    defaultMessage: 'Open',
  },
  close: {
    id: 'common.close',
    defaultMessage: 'Close',
  },
  currentLanguage: {
    id: 'common.current-language',
    defaultMessage: 'Current Language: {lang}. Click to change language.',
  },
  changeLanguage: {
    id: 'common.change-language',
    defaultMessage: 'Change language to {lang}',
  },
});



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/messages/commonMessages.js